import { Content as ContentType, NLGAction } from '@phrasee/phrasee-typings'
import { Element } from '@phrasee/phrasee-typings/typings/futurama/element'

import { getWsTopic } from './websocketMessage/helpers'

export type FullscreenGenerationWait = {
  isWaiting: boolean
  action?: NLGAction
}

export const getFullscreenGenerationWait = (
  content: ContentType | undefined,
  selectedRootElement: Element | undefined,
  isConnectionReady: boolean
): FullscreenGenerationWait => {
  if (!isConnectionReady || !content) {
    return { isWaiting: false }
  }

  const generateGlobalBriefWsTopic = getWsTopic({
    action: 'generateGlobalBrief',
    data: { contentId: content._id },
  })

  if (
    content.ws_messages?.some(
      (msg) => msg.wsTopic === generateGlobalBriefWsTopic
    )
  ) {
    return { isWaiting: true, action: 'brief' }
  }

  if (
    !selectedRootElement &&
    content.ws_messages?.some((msg) =>
      msg.wsTopic.includes('generateElementVariants')
    )
  ) {
    return { isWaiting: true, action: 'variants' }
  }

  if (selectedRootElement) {
    const generateElementBriefTopic = getWsTopic({
      action: 'generateElementBrief',
      data: {
        contentId: content._id,
        elementId: selectedRootElement.element_id,
      },
    })

    const generateElementVariantsTopic = getWsTopic({
      action: 'generateElementVariants',
      data: {
        contentId: content._id,
        elementId: selectedRootElement.element_id,
      },
    })

    if (
      content.ws_messages?.some(
        (msg) => msg.wsTopic === generateElementBriefTopic
      )
    ) {
      return { isWaiting: true, action: 'brief' }
    }

    if (
      content.ws_messages?.some(
        (msg) => msg.wsTopic === generateElementVariantsTopic
      )
    ) {
      return { isWaiting: true, action: 'variants' }
    }
  }

  return { isWaiting: false }
}
